
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class DatePicker extends Vue {
  @Prop({ type: String, required: true }) public value: string;

  public datePickerOpen = false;
  public date = '';

  public dateChanged(): void {
    this.datePickerOpen = false;
    this.$emit('changeDate', this.date);
  }

  @Watch('value', { immediate: true })
  private watchValue() {
    this.date = this.value;
  }
}
